import { ProxyDetails } from '../types';

export const adaptProxies = (rawData: Array<ProxyDetails>, onDelete: (proxyDetails: ProxyDetails) => void, isDeletable) => rawData.map((item: ProxyDetails) => ({
    ...item,
    actionCol: {
        onProxyDelete: () => onDelete(item),
        isDeletable,
    },
}));
